import { Autocomplete, Box, TextField, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { Controller, useForm, useWatch } from 'react-hook-form';

import { ParameterClass, ParameterSetAttribute } from '~pages/SipConfiguration/domain';

import { ContactFlowNodeProps } from '..';
import BaseNode from '../BaseNode';

export default function SetAttributeNode(props: ContactFlowNodeProps) {
  const form = useForm<ParameterSetAttribute>({
    defaultValues: props.data.parameter.setAttribute,
  });
  return (
    <BaseNode
      {...props}
      title='Set Attribute'
      parameterForm={form}
      renderParameterForm={(setAttribute) => (
        <>
          <Typography>Class: {setAttribute?.class || '--'}</Typography>
          <Typography>Key: {setAttribute?.name || '--'}</Typography>
          <Typography>Value: {setAttribute?.field || '--'}</Typography>
        </>
      )}
      transformParameter={(setAttribute) => ({ setAttribute })}
      renderEditParameter={({ control, setValue }) => {
        const setAttributeClass = useWatch({
          control,
          name: 'class',
        });
        // TODO: custom component each class
        const hideValue = setAttributeClass == ParameterClass.CmpDTMF;
        useEffect(() => {
          if (hideValue) {
            setValue('field', '');
          }
        }, [hideValue]);
        return (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 1,
            }}>
            <Controller
              control={control}
              name='name'
              rules={{ required: 'Key is required.' }}
              defaultValue=''
              render={({ field }) => <TextField {...field} fullWidth label='Key' />}
            />
            <Controller
              control={control}
              name='class'
              rules={{ required: 'Class is required.' }}
              render={({ field: { value, onChange, ...rest }, fieldState: { error } }) => (
                <Autocomplete
                  {...rest}
                  fullWidth
                  options={[ParameterClass.CmpDTMF, ParameterClass.CmpLiteral]}
                  renderInput={(params) => (
                    <TextField {...params} label='Class' error={Boolean(error)} helperText={error?.message} />
                  )}
                  value={value || null}
                  onChange={(e, v) => {
                    onChange(v);
                  }}
                />
              )}
            />
            {!hideValue && (
              <Controller
                control={control}
                name='field'
                defaultValue=''
                render={({ field }) => <TextField {...field} fullWidth label='Value' />}
              />
            )}
          </Box>
        );
      }}
    />
  );
}
